import { render, staticRenderFns } from "./EditarDadoModal.vue?vue&type=template&id=581e00d8&scoped=true"
import script from "./EditarDadoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditarDadoModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e00d8",
  null
  
)

export default component.exports